export default {"src":"/_next/static/media/minillus-gift.c534b5d9.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};